import { DEFAULT_SCHEDULE } from "../../../global/utility/scheduleTimeUtils";

export default function getSingleDeviceProfile(
  deviceProfiles,
  id,
  deviceTypes = []
) {
  if (Array.isArray(deviceProfiles) && deviceProfiles.length > 0) {
    const deviceProfile = deviceProfiles.filter(
      (deviceProfile) => deviceProfile.profileid === id
    );
    let step2 = {
      autoResolveForAllAlert: deviceProfile[0]?.autoresolve,
    };

    const deviceProfileAttributes =
      Array.isArray(deviceTypes) && deviceTypes.length > 0
        ? deviceTypes.filter(
            (deviceType) => deviceType?.value === deviceProfile[0]?.devicetype
          )
        : [];

    deviceProfile[0]?.attributes.forEach((attribute) => {
      const filterKey =
        attribute?.name?.toLowerCase() === "rfsignal"
          ? "Cellular Signal Strength"
          : attribute?.name;
      const attrName = attribute?.name?.trim();
      const attrKey = attrName?.toLowerCase();
      let customFields = {};
      if (attrName === "Tilt") {
        customFields = {
          tiltAngle: attribute?.tiltAngle,
          alarmType: 5,
          holdoff: 60,
          setOnlyOnce: 0,
          tiltDuration: 5.0,
          clearDuration: 10.0,
          x_axis: 1,
          y_axis: 1,
          z_axis: 1,
        };
      } else if (attrName === "Shock") {
        customFields = {
          shockThresh: attribute?.shockThresh,
          alarmType: 12,
          holdoff: 60,
          locationRequired: 0,
          setOnlyOnce: 0,
          shockDuration: 0.1,
          x_axis: 1,
          y_axis: 1,
          z_axis: 1,
        };
      } else if (attrName === "Anymotion") {
        customFields = {
          accelThresh: attribute?.accelThresh,
          stoppedThresh: attribute?.stoppedThresh,
          stoppedPeriod: attribute?.stoppedPeriod,
          alarmType: 5,
          holdoff: 60,
          locationRequired: 0,
          setOnlyOnce: 0,
        };
      }
      const isSpecialAttr = ["Tilt", "Shock", "Anymotion"].includes(attrName);
      step2 = {
        ...step2,
        [attrKey]: {
          alert: {
            isValid: true,
            class: "",
            value: attribute?.alert || "",
            error: "",
          },
          ...(isSpecialAttr
            ? {}
            : {
                minimum: {
                  isValid: true,
                  class: "",
                  minimum:
                    deviceProfileAttributes[0]?.attributes?.filter(
                      (attrib) => attrib?.name === filterKey
                    )[0]?.min || 0,
                  value: attribute?.min,
                  error: "",
                },
                maximum: {
                  isValid: true,
                  class: "",
                  maximum:
                    deviceProfileAttributes[0]?.attributes?.filter(
                      (attrib) => attrib?.name === filterKey
                    )[0]?.max || 0,
                  value: attribute?.max,
                  error: "",
                },
              }),
          alertType: {
            isValid: true,
            class: "",
            value: attribute?.alertType || "none",
            error: "",
          },
          alertGroup: {
            isValid: true,
            class: "",
            value: attribute?.alertGroup || null,
            error: "",
          },
          ...customFields,
          schedule: attribute?.customTimeFrame
            ? { ...DEFAULT_SCHEDULE, ...attribute.customTimeFrame }
            : { ...DEFAULT_SCHEDULE },
        },
      };
    });

    let frequency = {
      reportingFrequency: {
        value: undefined,
        unit: undefined,
      },
      monitorFrequency: {
        value: undefined,
        unit: undefined,
      },
    };

    if (
      Array.isArray(deviceProfile) &&
      deviceProfile.length === 1 &&
      Object.hasOwn(deviceProfile[0], "frequencies") &&
      deviceProfile[0].frequencies &&
      // Object.hasOwn(deviceProfile[0].frequencies, "capturesensorvalues") &&
      // deviceProfile[0].frequencies?.capturesensorvalues
      Object.hasOwn(deviceProfile[0].frequencies, "sensordatafrequency") &&
      deviceProfile[0].frequencies?.sensordatafrequency
    ) {
      const reportingFrequencyArr =
        //`${deviceProfile[0].frequencies?.capturesensorvalues}`.split(" ");
        `${deviceProfile[0].frequencies?.sensordatafrequency}`.split(" ");

      if (
        Array.isArray(reportingFrequencyArr) &&
        reportingFrequencyArr.length === 2
      ) {
        frequency = {
          ...frequency,
          reportingFrequency: {
            value: reportingFrequencyArr[0],
            unit: reportingFrequencyArr[1],
          },
        };
      } else if (
        Array.isArray(reportingFrequencyArr) &&
        reportingFrequencyArr.length === 1
      ) {
        frequency = {
          ...frequency,
          reportingFrequency: {
            value: reportingFrequencyArr[0],
            unit: undefined,
          },
        };
      }
    }

    if (
      Array.isArray(deviceProfile) &&
      deviceProfile.length === 1 &&
      Object.hasOwn(deviceProfile[0], "frequencies") &&
      deviceProfile[0].frequencies &&
      // Object.hasOwn(deviceProfile[0].frequencies, "sensordatafrequency") &&
      // deviceProfile[0].frequencies?.sensordatafrequency
      Object.hasOwn(deviceProfile[0].frequencies, "capturesensorvalues") &&
      deviceProfile[0].frequencies?.capturesensorvalues
    ) {
      const monitorFrequencyArr =
        // `${deviceProfile[0].frequencies?.sensordatafrequency}`.split(" ");
        `${deviceProfile[0].frequencies?.capturesensorvalues}`.split(" ");
      if (
        Array.isArray(monitorFrequencyArr) &&
        monitorFrequencyArr.length === 2
      ) {
        frequency = {
          ...frequency,
          monitorFrequency: {
            value: monitorFrequencyArr[0],
            unit: monitorFrequencyArr[1],
          },
        };
      } else if (
        Array.isArray(monitorFrequencyArr) &&
        monitorFrequencyArr.length === 1
      ) {
        frequency = {
          ...frequency,
          monitorFrequency: {
            value: monitorFrequencyArr[0],
            unit: undefined,
          },
        };
      }
    }
let nonshipstep3 = {};
if (
  deviceProfile[0]?.profiletype === "nonshipment" &&
  deviceProfileAttributes[0]?.devicemodel === "GAT"
) {
  if (Array.isArray(deviceProfile[0]?.locations) && deviceProfile[0]?.locations.length > 0) {
    const location = deviceProfile[0].locations[0]; // take first location
    nonshipstep3 = {
      nonshipsetalert: location?.setAlert,
      nonshipusecase: {
        useCase: {
          isValid: false,
          class: "",
          value: location?.usecase,
          error: "",
        },
      },
      inventoryMgmt: {
        assetthreshold: {
          isValid: false,
          class: "",
          value: location?.assetThreshold,
          error: "",
        },
        assettype: {
          isValid: false,
          class: "",
          value: location?.assetType,
          error: "",
        },
        alerttype: {
          isValid: false,
          class: "",
          value: "notification",
          error: "",
        },
        alertgroup: {
          isValid: false,
          class: "",
          value: location?.alertgroup,
          error: "",
        },
      },
      alerttype: {
        isValid: true,
        class: "",
        value: location?.alerttype || "notification",
        error: "",
      },
    };
  }
} else if (
  deviceProfile[0]?.profiletype === "nonshipment" &&
  deviceProfileAttributes[0]?.devicemodel === "BLE"
) {
 if (Array.isArray(deviceProfile[0]?.locations) && deviceProfile[0]?.locations.length > 0) {
    const location = deviceProfile[0].locations[0]; // take first location
    nonshipstep3 = {
      nonshipsetalert: location?.setAlert,
      nonshipbleloc: {
        locationzone: {
          isValid: false,
          class: "",
          value: location?.locationZone,
          error: "",
        },
        trigger: {
          isValid: false,
          class: "",
          value: location?.trigger,
          error: "",
        },
        alerttype: {
          isValid: false,
          class: "",
          value: "notification",
          error: "",
        },
        alertgroup: {
          isValid: false,
          class: "",
          value: location?.alertgroup,
          error: "",
        },
      },
      alerttype: {
        isValid: true,
        class: "",
        value: location?.alerttype || "notification",
        error: "",
      },
    };
  }
}



    return {
      single: {
        id,
        name: deviceProfile[0]?.profilename,
        deviceProfile: deviceProfile[0],
      },
      fields: {
        step1: {
          profileName: {
            isValid: true,
            isRequired: true,
            class: "",
            value: deviceProfile[0]?.profilename,
            error: "",
          },
           profileType: {
            isValid: true,
            isRequired: true,
            class: "",
            value: deviceProfile[0]?.profiletype==="nonshipment"?"nonshipment":"shipment",
            error: "",
          },
          deviceType: {
            isValid: true,
            isRequired: true,
            class: "",
            value: deviceProfile[0]?.devicetype,
            error: "",
          },
          description: {
            isValid: true,
            class: "",
            value: deviceProfile[0]?.description,
            error: "",
          },
          devicemodel:deviceProfileAttributes,
          attributes: deviceProfile[0]?.attributes.map((attribute) => ({
            key: `${attribute?.name?.toLowerCase()}_(${attribute?.unit})`,
            title: `${attribute?.name} (${attribute?.unit})`,
            stateSelector: attribute?.name?.toLowerCase(),
            isMinimumVisible: true,
          })),
        },
        step2: step2,
        step3: {
          locations:
            deviceProfile[0]?.locations &&
            Array.isArray(deviceProfile[0]?.locations) &&
            deviceProfile[0]?.locations?.length > 0
              ? deviceProfile[0]?.locations?.map((location) => {
                  const loc_type = location.type || "existing";
                  return {
                    currentLocation: location.type || "existing",
                    [loc_type]: {
                      shipping: {
                        isValid: location.locationtype !== undefined,
                        class: "",
                        value: location.locationtype,
                        error: "",
                      },
                      pointName: {
                        isValid: location.name !== "",
                        class: "",
                        value: location.name,
                        error: "",
                      },
                      address: {
                        isValid: location.address !== "",
                        class: "",
                        value: location.address,
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                              .Input {
                                  height: 44px;
                                  font-size: 1rem;
                                  font-weight: 400;
                                  color: #212529;
                                  font-family: system-ui;
                                  pointer-events: none;
                              }
                              .ClearBtn {
                                  display: none !important;
                              }
                          `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: location.latitude !== "",
                        class: "",
                        value: location.latitude,
                        error: "",
                      },
                      longitude: {
                        isValid: location.longitude !== "",
                        class: "",
                        value: location.longitude,
                        error: "",
                      },
                      trigger: {
                        isValid: location.trigger !== "",
                        class: "",
                        value: location.trigger || "entry and exit",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: location.radius,
                        error: "",
                      },
                      alerttype: {
                        isValid: true,
                        class: "",
                        value: location?.alerttype,
                        error: "",
                      },
                      alertgroup: {
                        isValid: true,
                        class: "",
                        value: location?.alertgroup,
                        error: "",
                      },
                    },
                    [loc_type === "existing" ? "new" : "existing"]: {
                      shipping: {
                        isValid: location.locationtype !== undefined,
                        class: "",
                        value: location.locationtype,
                        error: "",
                      },
                      pointName: {
                        isValid: location.name !== "",
                        class: "",
                        value: "",
                        error: "",
                      },
                      address: {
                        isValid: location.address !== "",
                        class: "",
                        value: "",
                        error: "",
                        mapBoxTheme: {
                          cssText: `
                              .Input {
                                  height: 44px;
                                  font-size: 1rem;
                                  font-weight: 400;
                                  color: #212529;
                                  font-family: system-ui;
                                  pointer-events: none;
                              }
                              .ClearBtn {
                                  display: none !important;
                              }
                          `,
                          variables: {
                            unit: "14px",
                            padding: "0.5em",
                            border: "1px solid rgba(111, 113, 113, 1)",
                            borderRadius: "4px",
                            boxShadow: "none",
                          },
                        },
                      },
                      latitude: {
                        isValid: location.latitude !== "",
                        class: "",
                        value: "",
                        error: "",
                      },
                      longitude: {
                        isValid: location.longitude !== "",
                        class: "",
                        value: "",
                        error: "",
                      },
                      trigger: {
                        isValid: location.trigger !== "",
                        class: "",
                        value: "entry and exit",
                        error: "",
                      },
                      radius: {
                        isValid: true,
                        class: "",
                        value: 500,
                        error: "",
                      },
                      alerttype: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                      alertgroup: {
                        isValid: true,
                        class: "",
                        value: "",
                        error: "",
                      },
                    },
                  };
                })
              : [],
        },
        nonshipstep3:nonshipstep3,
        step4: {
          reportingFrequency: {
            value: {
              isValid: true,
              class: "",
              value: deviceProfile[0]?.frequencies?.hasOwnProperty(
                //"capturesensorvalues"
                "sensordatafrequency"
              )
                ? frequency?.reportingFrequency?.value
                : "None",
              error: "",
            },
            unit: {
              isValid: true,
              class: "",
              value: frequency?.reportingFrequency?.unit || undefined,
              error: "",
            },
          },
          monitorFrequency: {
            value: {
              isValid: true,
              class: "",
              value: deviceProfile[0]?.frequencies?.hasOwnProperty(
                //"sensordatafrequency"
                "capturesensorvalues"
              )
                ? frequency?.monitorFrequency?.value
                : "None",
              error: "",
            },
            unit: {
              isValid: true,
              class: "",
              value: frequency?.monitorFrequency?.unit || undefined,
              error: "",
            },
          },
        },
      },
    };
  }
  return null;
}
